import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Image10 from "../../assets/img/portfolio/portfolio-10.jpg";
import Image6 from "../../assets/img/portfolio/portfolio-6.jpg";
import Image7 from "../../assets/img/portfolio/portfolio-7.jpg";
import Image8 from "../../assets/img/portfolio/portfolio-8.jpg";
import Image9 from "../../assets/img/portfolio/portfolio-9.jpg";
import React from "react";
import Slider from "react-slick";

// Import css files

function PortfolioSlider2() {
	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		cssEase: "linear",
		pauseOnHover: true,
		rtl: true,
		dots: false,
		arrows: false,
	};

	return (
		<Slider {...settings}>
			{/* Portfolio-6 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:mr-auto md:w-1/2 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-l lg:py-14 h-full'>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Corporate - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							DukeNPaul Website
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-32'>
							A Leading provider of signs for businesses, organizations, and
							individuals in Nigeria. We pride ourselves on being the best
							signage company, committed to excellent service and quality.
						</p>
						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor
							</p>
						</div>
						<div className='mt-8 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://dukenpaulsignage.com/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VISIT WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='h-56 bg-indigo-600 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image6} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-7 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:mr-auto md:w-1/2 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-l lg:py-14 h-full'>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Food Delivery - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							BiteExpress Web
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-32'>
							Get food, drinks, and more delivered with BiteExpress! Enjoy a
							diverse menu from top restaurants, delivered straight to you.
							Quick meals or special occasions, we've got you covered.
						</p>
						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>Flutter</p>
						</div>
						<div className='mt-8 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://web.biteexpress.ng/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VISIT WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='h-56 bg-indigo-600 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image7} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-8 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:mr-auto md:w-1/2 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-l lg:py-14 h-full'>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Social Network - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Kreador Website
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-32'>
							Connect and collaborate with software engineers on our specialized
							social network app. Showcase projects, share knowledge, and stay
							updated in the ALX software engineering community!
						</p>
						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								Boostrap | HTML | JavaScript
							</p>
						</div>
						<div className='mt-8 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://kreador.netlify.app'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VISIT WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='h-56 bg-indigo-600 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image8} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-9 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:mr-auto md:w-1/2 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-l lg:py-14 h-full'>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Link Shortener - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							URLShortener Website
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-32'>
							URLShortener is a convenient web app for creating short links from
							long URLs. Share easily on social media, email, and more without
							the hassle of lengthy and complex URLs.
						</p>

						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								Reactjs | TailwindCSS | Nodejs | MongoDB | RESTful API 
							</p>
						</div>
						<div className='mt-8 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://shortenmyurl.netlify.app/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VISIT WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='h-56 bg-indigo-600 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image9} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-10 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:mr-auto md:w-1/2 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-l lg:py-14 h-full'>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Agricultural - Website
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							SoftNaija
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-32'>
							SoftNaija: Nourishing Communities, One Meal at a Time. they are
							dedicated to building a supportive ecosystem that celebrates the
							power of food, people, and shared values.
						</p>
						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor
							</p>
						</div>
						<div className='mt-8 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://www.softnaija.ng/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VISIT WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className='h-56 bg-indigo-600 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image10} alt='' />
					</div>
				</div>
			</div>
		</Slider>
	);
}

export default PortfolioSlider2;
